import pug from 'javascripts/auth/templates/oauth_error.jst.pug';
window.JST = window.JST || {};
window.JST['auth/templates/oauth_error'] = pug;
